import { Box, Button, FormHelperText, useTheme } from "@mui/material";
import { Plus } from "lucide-react";
import {
  Controller,
  useFieldArray,
  UseFormReturn,
  useWatch,
} from "react-hook-form";
import FinancialCostSharePayment from "./financial-cost-share-payment";
import { FinancialDetailsFormFields } from "@/modules/property-tracks/hooks/rental-financial-proposal/multi-step-form.hook";
import { useMemo } from "react";

interface FinancialCostSharePaymentsProps {
  form: UseFormReturn<FinancialDetailsFormFields>;
  clientTotalCostShare: number;
}

export default function FinancialCostSharePayments({
  form,
  clientTotalCostShare,
}: FinancialCostSharePaymentsProps) {
  const theme = useTheme();

  const payments = useFieldArray({
    control: form.control,
    name: "paymentPlan",
  });

  const paymentValues = useWatch({
    control: form.control,
    name: "paymentPlan",
  });

  const totalPercentage = useMemo(
    () =>
      paymentValues?.reduce(
        (sum, payment) => Number(sum) + Number(payment.percentage),
        0
      ) || 0,
    [paymentValues]
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: theme.nawy.spacing.md,
      }}
    >
      <Controller
        control={form.control}
        name="paymentPlan"
        render={({ fieldState }) => (
          <FormHelperText error>
            {fieldState.error?.root?.message || fieldState.error?.message}
          </FormHelperText>
        )}
      />
      {payments.fields.map((field, index) => (
        <FinancialCostSharePayment
          key={field.id}
          form={form}
          index={index}
          totalCount={payments.fields.length}
          totalAmount={clientTotalCostShare}
          remove={payments.remove}
        />
      ))}
      {totalPercentage < 100 && (
        <Box>
          <Button
            startIcon={<Plus />}
            onClick={() => payments.append({ amount: 0, percentage: 0 })}
          >
            Add month
          </Button>
        </Box>
      )}
    </Box>
  );
}
